import { motion } from "framer-motion";
import { Radar, Repeat2, Bike } from "lucide-react";
import { fadeUp, staggerContainer, viewportOnce } from "@/lib/motion";

const STEPS = [
  {
    n: "01",
    icon: Radar,
    title: "Live Search",
    text: "Search for medicines and see live inventory across local independent pharmacies in real-time.",
    color: "var(--action-green)",
    testId: "step-live-search",
  },
  {
    n: "02",
    icon: Repeat2,
    title: "Reserve or Substitute",
    text: "Reserve your medicine for pickup or find valid medical substitutes instantly if a brand is out of stock.",
    color: "#0f172a",
    testId: "step-reserve-substitute",
  },
  {
    n: "03",
    icon: Bike,
    title: "Fast Delivery",
    text: "Delivered to your door in under an hour.",
    color: "var(--urgent-orange)",
    testId: "step-fast-delivery",
  },
];

export const HowItWorks = () => {
  return (
    <section
      className="relative bg-white py-24 sm:py-32"
      id="how-it-works"
      data-testid="how-it-works-section"
    >
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          variants={fadeUp}
          className="max-w-2xl"
        >
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
            How it works
          </p>
          <h2 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            Three steps between you and your medicine.
          </h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          variants={staggerContainer}
          className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3"
        >
          {STEPS.map((s) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.n}
                variants={fadeUp}
                data-testid={s.testId}
                className="group relative flex h-full flex-col rounded-2xl border border-slate-100 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_-18px_rgba(15,23,42,0.22)]"
              >
                <span className="font-display text-6xl font-extrabold text-slate-100 transition-colors duration-300 group-hover:text-slate-200">
                  {s.n}
                </span>
                <div
                  className="mt-4 grid h-12 w-12 place-items-center rounded-xl text-white"
                  style={{ backgroundColor: s.color }}
                >
                  <Icon size={22} strokeWidth={2.3} aria-label={s.title} />
                </div>
                <h3 className="font-display mt-6 text-xl font-bold text-slate-900">
                  {s.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-slate-600">
                  {s.text}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;
